import { decodeAddress, encodeAddress } from '@polkadot/keyring'
import { evmToAddress } from '@polkadot/util-crypto'
import type { Chain } from './chain'
import type { PolkadotAddress, PolkadotAssetId, PolkadotSource } from './types'

export const createPolkadotSource = (params: {
  chainId: number
  blockNumber: number
  extrinsicIndex?: number
}): PolkadotSource => {
  return params.extrinsicIndex === undefined
    ? `polkadot_${params.chainId}_${params.blockNumber}`
    : `polkadot_${params.chainId}_${params.blockNumber}-${params.extrinsicIndex}`
}

export const createPolkadotAddress = (params: {
  chainId: number
  address: string
}): PolkadotAddress => `polkadot_${params.chainId}_${params.address}`

export const createPolkadotAssetId = (params: {
  chainId: number
  assetId: bigint
}): PolkadotAssetId => `polkadot_${params.chainId}_${params.assetId}`

export const parseAddressToOtherChain = (params: {
  address: string
  toChain: Chain
  debug?: (message: unknown) => void
}): string | undefined => {
  const { address, toChain, debug } = params
  try {
    const decoded = decodeAddress(address)
    return encodeAddress(decoded, toChain.ss58Prefix)
  } catch (error) {
    if (debug !== undefined) {
      debug(error)
    }
    return undefined
  }
}

export const parseFromEvmAddress = (params: {
  address: string
  toChain: Chain
}): string => {
  const { address, toChain } = params
  return evmToAddress(address, toChain.ss58Prefix)
}

export const divideArrayIntoChunks = <T>(
  items: readonly T[],
  chunkSize: number,
): readonly (readonly T[])[] => {
  if (items.length === 0) {
    return []
  }
  const mut_chunks: T[][] = []
  for (let index = 0; index < items.length; index += chunkSize) {
    mut_chunks.push(items.slice(index, index + chunkSize))
  }
  return mut_chunks
}
